export const AUTH_TOKEN_STORAGE_KEYS = {
  DEVICE_ID: 'device-id',
  APP_TOKEN: 'aspora-app-frontend-token',
  USER_ROLE: 'aspora-app-user-role'
};